export default __webpack_public_path__ + "static/media/tf_profile.43871317.svg";